export default __webpack_public_path__ + "static/media/green_flag.d03df3c1.png";